export default {
  INSTITUTION: 'Einrichtung',
  ESTABLISHMENT: 'Betriebsstätte',
  ESTABLISHMENT_DOCTOR: 'Arzt',
  DOCTOR: 'Arzt',
  SERVICE_START: 'Dienstbeginn',
  SERVICE_END: 'Dienstende',
  HOURS_ABBR: 'Std.',
};
